import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/cart.png'
import _imports_1 from '../assets/harmony.gif'
import _imports_2 from '../assets/effort.gif'
import _imports_3 from '../assets/database.gif'
import _imports_4 from '../assets/folder.gif'
import _imports_5 from '../assets/crud.gif'
import _imports_6 from '../assets/datalaptop.gif'
import _imports_7 from '../assets/detail_xbtn.svg'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "section s_project",
  id: "s_project"
}
const _hoisted_3 = { class: "btnsection" }
const _hoisted_4 = { class: "con_list" }
const _hoisted_5 = {
  key: 0,
  class: "list_s"
}
const _hoisted_6 = {
  key: 1,
  class: "list_a"
}
const _hoisted_7 = { class: "section s_about" }
const _hoisted_8 = { class: "section s_career" }
const _hoisted_9 = { class: "text-wrap" }
const _hoisted_10 = { class: "c_row" }
const _hoisted_11 = {
  key: 0,
  class: "c_back"
}
const _hoisted_12 = {
  key: 0,
  class: "c_back"
}
const _hoisted_13 = {
  key: 0,
  class: "c_back"
}
const _hoisted_14 = {
  key: 0,
  class: "c_back"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IntroSection = _resolveComponent("IntroSection")!
  const _component_ProjectList = _resolveComponent("ProjectList")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_Strong = _resolveComponent("Strong")!
  const _component_SubSection = _resolveComponent("SubSection")!
  const _component_PopupItem = _resolveComponent("PopupItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_IntroSection),
      _cache[45] || (_cache[45] = _createStaticVNode("<div class=\"section s_cart\"><p class=\"cart_p\">어떤 인재를<i>주문하셨나요?</i> <span> 메뉴에서 골라</span><span>테이크 아웃하세요 !</span></p><figure><img src=\"" + _imports_0 + "\" alt=\"움직이는 gif\"></figure></div><div class=\"section s_service\"><div class=\"text-wrap\"><h5>원하시는 인재가 있으신가요?</h5><h3>WHAT YOUR CHOICE</h3></div><ul><li class=\"scrolling-text\"><div><span>#성실함</span><span class=\"icon icon_h\"><img src=\"" + _imports_1 + "\" alt=\"융화 움직이는 아이콘\">#융화</span><span>#자기개발</span><span>#지구력</span><span class=\"icon icon_e\"><img src=\"" + _imports_2 + "\" alt=\"노력 움직이는 아이콘\">#노력파</span><span>#창의력</span></div><div><span>#성실함</span><span class=\"icon icon_h\"><img src=\"" + _imports_1 + "\" alt=\"융화 움직이는 아이콘\">#융화</span><span>#자기개발</span><span>#지구력</span><span class=\"icon icon_e\"><img src=\"" + _imports_2 + "\" alt=\"노력 움직이는 아이콘\">#노력파</span><span>#창의력</span></div><div><span>#성실함</span><span class=\"icon icon_h\"><img src=\"" + _imports_1 + "\" alt=\"융화 움직이는 아이콘\">#융화</span><span>#자기개발</span><span>#지구력</span><span class=\"icon icon_e\"><img src=\"" + _imports_2 + "\" alt=\"노력 움직이는 아이콘\">#노력파</span><span>#창의력</span></div></li><li class=\"scrolling-text\"><div><span class=\"icon icon_j\"><img src=\"" + _imports_3 + "\" alt=\"자바 움직이는 아이콘\">#JAVASCRIPT</span><span>#REACT, VUE</span><span>#전역상태관리</span><span class=\"icon icon_f\"><img src=\"" + _imports_4 + "\" alt=\"자바 움직이는 아이콘\">#폴더구조</span><span>#TYPESCRIPT</span><span>#NEXT</span></div><div><span class=\"icon icon_j\"><img src=\"" + _imports_3 + "\" alt=\"자바 움직이는 아이콘\">#JAVASCRIPT</span><span>#REACT, VUE</span><span>#전역상태관리</span><span class=\"icon icon_f\"><img src=\"" + _imports_4 + "\" alt=\"자바 움직이는 아이콘\">#폴더구조</span><span>#TYPESCRIPT</span><span>#NEXT</span></div><div><span class=\"icon icon_j\"><img src=\"" + _imports_3 + "\" alt=\"자바 움직이는 아이콘\">#JAVASCRIPT</span><span>#REACT, VUE</span><span>#전역상태관리</span><span class=\"icon icon_f\"><img src=\"" + _imports_4 + "\" alt=\"자바 움직이는 아이콘\">#폴더구조</span><span>#TYPESCRIPT</span><span>#NEXT</span></div></li><li class=\"scrolling-text\"><div><span>#REST API</span><span class=\"icon icon_c\"><img src=\"" + _imports_5 + "\" alt=\"crud 움직이는 아이콘\">#CRUD 구현</span><span>#UI,UX 개선</span><span>#데이터 베이스</span><span class=\"icon icon_d\"><img src=\"" + _imports_6 + "\" alt=\"데이터 움직이는 아이콘\">#데이터 분석</span><span>#JSON</span></div><div><span>#REST API</span><span class=\"icon icon_c\"><img src=\"" + _imports_5 + "\" alt=\"crud 움직이는 아이콘\">#CRUD 구현</span><span>#UI,UX 개선</span><span>#데이터 베이스</span><span class=\"icon icon_d\"><img src=\"" + _imports_6 + "\" alt=\"데이터 움직이는 아이콘\">#데이터 분석</span><span>#JSON</span></div><div><span>#REST API</span><span class=\"icon icon_c\"><img src=\"" + _imports_5 + "\" alt=\"crud 움직이는 아이콘\">#CRUD 구현</span><span>#UI,UX 개선</span><span>#데이터 베이스</span><span class=\"icon icon_d\"><img src=\"" + _imports_6 + "\" alt=\"데이터 움직이는 아이콘\">#데이터 분석</span><span>#JSON</span></div></li></ul></div>", 2)),
      _createElementVNode("div", _hoisted_2, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-wrap" }, [
          _createElementVNode("h5", null, "주문하신 메뉴 나왔습니다!"),
          _createElementVNode("h3", null, "PROJECT")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["albumbtn", { active: _ctx.viewMode === 'album' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewMode = 'album'))
          }, null, 2),
          _cache[11] || (_cache[11] = _createElementVNode("span", null, "|", -1)),
          _createElementVNode("button", {
            class: _normalizeClass(["slidebtn", { active: _ctx.viewMode === 'swiper' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewMode = 'swiper'))
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.viewMode === 'swiper')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_Swiper, {
                  ref: "{swiperRef}",
                  slidesPerView: 3,
                  pagination: {
          clickable: true, },
                  navigation: true,
                  modules: _ctx.modules,
                  class: "mySwiper",
                  breakpoints: {360: { slidesPerView: 1 },1027: { slidesPerView: 1 },1028: { slidesPerView: 3 }}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, i) => {
                      return (_openBlock(), _createBlock(_component_swiper_slide, { key: i }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ProjectList, {
                            project: project,
                            onParent: _ctx.showPopup
                          }, null, 8, ["project", "onParent"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modules"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.viewMode === 'album')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, i) => {
                  return (_openBlock(), _createBlock(_component_ProjectList, {
                    key: i,
                    project: project,
                    onParent: _ctx.showPopup
                  }, null, 8, ["project", "onParent"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text-wrap" }, [
          _createElementVNode("h5", null, "자기 소개 및 관련 사항"),
          _createElementVNode("h3", null, "About Me")
        ], -1)),
        _cache[31] || (_cache[31] = _createElementVNode("div", {
          class: "canvas",
          id: "memberRenderBox"
        }, null, -1)),
        _createElementVNode("p", null, [
          _cache[15] || (_cache[15] = _createTextVNode("안녕하세요! 생각의 경계를 넘어서는 ")),
          _cache[16] || (_cache[16] = _createElementVNode("strong", null, "유연한 사고", -1)),
          _cache[17] || (_cache[17] = _createTextVNode("와 ")),
          _cache[18] || (_cache[18] = _createElementVNode("strong", null, "혁신적인 발상", -1)),
          _cache[19] || (_cache[19] = _createTextVNode("으로 ")),
          _cache[20] || (_cache[20] = _createElementVNode("strong", null, "무한한 가능성", -1)),
          _cache[21] || (_cache[21] = _createTextVNode("을 만들어내고 싶은 ")),
          _cache[22] || (_cache[22] = _createElementVNode("strong", null, "디자인하는 퍼블리셔 박지연", -1)),
          _cache[23] || (_cache[23] = _createTextVNode(" 입니다.")),
          _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
          _cache[25] || (_cache[25] = _createTextVNode(" 작은 단위의 ")),
          _createVNode(_component_Strong, null, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("컴포넌트를 재사용")
            ])),
            _: 1
          }),
          _cache[26] || (_cache[26] = _createTextVNode("하고 ")),
          _createVNode(_component_Strong, null, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("확장성을 고려")
            ])),
            _: 1
          }),
          _cache[27] || (_cache[27] = _createTextVNode("해 작업하는 것을 좋아하며 새롭게 배운 기술을 업무에 적용해 더 나은 서비스를")),
          _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
          _cache[29] || (_cache[29] = _createTextVNode(" 구축하는 것을 목표로 정진합니다. "))
        ]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToAbout && _ctx.goToAbout(...args)))
        }, "더보기")
      ]),
      _cache[46] || (_cache[46] = _createElementVNode("div", { class: "section s_interview" }, [
        _createElementVNode("div", { class: "text-wrap" }, [
          _createElementVNode("h5", null, "질문과 답변"),
          _createElementVNode("h3", null, "Interview")
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("h4", null, "Q) 디자이너에서 퍼블리셔로 전향한 이유?"),
            _createElementVNode("p", null, [
              _createTextVNode("첫 시작은 퍼블리싱이였습니다."),
              _createElementVNode("br"),
              _createTextVNode(" 퍼블리싱에 관심이 있어 혼자 독학으로 유튜브를 공부하다 화면을 내가 디자인한데로 구현해내는 것에 매료되었고 더 나아가 개발까지 공부하게 되었습니다.내가 기획한데로 디자인과 기능까지 모두 화면에 출력할 수 있겠다라는 생각에 전향을 결심하고 도전하게 되었습니다. ")
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("h4", null, "Q) 프로젝트를 하면서 가장 힘들었던 것은?"),
            _createElementVNode("p", null, "팀 작업을 할때는 모두의 의견을 조율하고 내가 맡은 부분을 시간 안에 끝내야 하는 책임감에 힘들었습니다. 하지만 서로의 지식을 나누고 공유할 수 있어 더욱 성장하는 기회가 된 것 같습니다. 개인 작업시에는 설계를 혼자서 다 해내야 한다는 점이 어려웠던 것 같습니다. 작업 전 미리 효율적인 로직과 구조를 짠다면 훨씬 빠르고 깔끔한 작업물이 나온다는 것을 몇번의 작업을 거치고 습득할 수 있었던 것 같습니다. ")
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[33] || (_cache[33] = _createElementVNode("h5", null, "경력 사항 및 교육", -1)),
          _createElementVNode("div", _hoisted_10, [
            _cache[32] || (_cache[32] = _createElementVNode("h3", null, "CAREER", -1)),
            _createElementVNode("button", {
              class: "morebtn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToCareer && _ctx.goToCareer(...args)))
            }, "더보기")
          ])
        ]),
        _createElementVNode("ul", null, [
          _cache[42] || (_cache[42] = _createElementVNode("li", { class: "unactive" }, [
            _createElementVNode("div", { class: "c_front" }, [
              _createElementVNode("span", null, "2024. 12. 01 ~"),
              _createElementVNode("h3", null, "무궁무진한 발전을 기약, 미래의 회사")
            ])
          ], -1)),
          _createElementVNode("li", {
            class: _normalizeClass(["spreadsection", { active: _ctx.isOpen(1) }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClick(1)))
          }, [
            _cache[35] || (_cache[35] = _createElementVNode("div", { class: "c_front" }, [
              _createElementVNode("span", null, "2018-09-10 ~ 2023-12-01 "),
              _createElementVNode("h3", null, "(주)베스트해피라인 / (주)금오H라인")
            ], -1)),
            (_ctx.isOpen(1))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[34] || (_cache[34] = [
                  _createElementVNode("span", null, "2018-09-10 ~ 2023-12-01 ", -1),
                  _createElementVNode("h3", null, "(주)베스트해피라인 / (주)금오H라인", -1),
                  _createElementVNode("p", null, "병ㆍ의원 운영 시스템을 갖춘 마케팅 컨설팅 회사로 오프라인 및 온라인 홍보 및 마케팅, 경영 관리를 지원하는 회사입니다. 온라인 마케팅 팀에 귀속되어 웹디자이너로 근무하였습니다. ", -1)
                ])))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["spreadsection", { active: _ctx.isOpen(2) }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClick(2)))
          }, [
            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "c_front" }, [
              _createElementVNode("span", null, "2015.3.23 ~ 2017.11.06"),
              _createElementVNode("h3", null, "(주)토다이 평촌점")
            ], -1)),
            (_ctx.isOpen(2))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[36] || (_cache[36] = [
                  _createElementVNode("span", null, "2015.3.23 ~ 2017.11.06", -1),
                  _createElementVNode("h3", null, "(주)토다이평촌점", -1),
                  _createElementVNode("p", null, "미국, 중국, 일본, 한국 등의 지점이 있는 씨푸드 레스토랑으로 일식, 중식, 한식, 양식, 패스츄리가 제공되는 패밀리 레스토랑입니다. 한식 & 패스츄리 파트에서 쿡으로 1년 8개월 근무, 양식파트에서 헤드쉐프로 1년 근무하였습니다. ", -1)
                ])))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["spreadsection", { active: _ctx.isOpen(3) }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onClick(3)))
          }, [
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "c_front" }, [
              _createElementVNode("span", null, "2013.2.15~2015.01.28"),
              _createElementVNode("h3", null, "호주 워킹홀리데이")
            ], -1)),
            (_ctx.isOpen(3))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[38] || (_cache[38] = [
                  _createElementVNode("span", null, "2013.2.15~2015.01.28", -1),
                  _createElementVNode("h3", null, "호주 워킹홀리데이", -1),
                  _createElementVNode("p", null, "학교에서 2011년 1월 경 5주 호주 연수 프로그램에 선발되어 어학 연수를 다녀왔던 경험을 토대로 워킹홀리데이에 도전하여 2년동안 스시 롤러, 딸기 농장, 청소 등 다양한 직업을 경험하고 글로벌 역량을 강화해 돌아왔습니다. ", -1)
                ])))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass(["spreadsection", { active: _ctx.isOpen(4) }]),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onClick(4)))
          }, [
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "c_front" }, [
              _createElementVNode("span", null, "2011.5.13 ~ 2012.07.29"),
              _createElementVNode("h3", null, "(주)호반호텔앤리조트")
            ], -1)),
            (_ctx.isOpen(4))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[40] || (_cache[40] = [
                  _createElementVNode("span", null, "2011.5.13 ~ 2012.07.29", -1),
                  _createElementVNode("h3", null, "(주)호반호텔앤리조트", -1),
                  _createElementVNode("p", null, "(주)리솜리조트라는 이름으로 설립된 리조트 운영 기업으로 제천, 안면도, 덕산, 제주에 지점들이 있으며 학동에 위치한 본사의 판촉팀에서 연회장 예약 및 관리를 담당하였습니다. ", -1)
                ])))
              : _createCommentVNode("", true)
          ], 2),
          _cache[43] || (_cache[43] = _createElementVNode("li", { class: "unactive" }, [
            _createElementVNode("div", { class: "c_front" }, [
              _createElementVNode("span", null, "2008.03 ~ 2011.02"),
              _createElementVNode("h3", null, "대림대 졸업")
            ])
          ], -1)),
          _cache[44] || (_cache[44] = _createElementVNode("li", { class: "unactive" }, [
            _createElementVNode("div", { class: "c_front" }, [
              _createElementVNode("span", null, "2005.03 ~ 2008.02"),
              _createElementVNode("h3", null, "산본고 졸업")
            ])
          ], -1))
        ])
      ]),
      _createVNode(_component_SubSection)
    ]),
    (_ctx.popup)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "black-bg",
          id: "black-bg",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleClick($event)))
        }, [
          _createElementVNode("div", {
            class: "white-bg",
            onScroll: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
          }, [
            (_ctx.selectedProject)
              ? (_openBlock(), _createBlock(_component_PopupItem, {
                  key: 0,
                  project: _ctx.selectedProject
                }, null, 8, ["project"]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args))),
              class: "detail_xbtn"
            }, _cache[47] || (_cache[47] = [
              _createElementVNode("img", {
                src: _imports_7,
                alt: "닫기버튼"
              }, null, -1)
            ]))
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}